import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";
import Loader from "../components/Loader";

const WALLETS = {
  USDTTRC: { name: "Tether (TRC20)", label: "USDTTRC - Tether (TRC20)", address: "TBLZM2pVnUjcUhGUUFBXvPwRN6uXbhAQ9k" },
  LTC:     { name: "Litecoin",       label: "LTC - Litecoin",            address: "LLiuhK4uDRWf2WhNVHnqXhfLrzAwUnptB7" },
  BTC:     { name: "Bitcoin",        label: "BTC - Bitcoin",             address: "18qgSo7R1xpmevVmvLL4oH1nCd4Z34HJbT" },
};

function Wallet() {
  const [loading, setLoading]         = useState(true);
  const [submitted, setSubmitted]     = useState(false);
  const [amount, setAmount]           = useState("");
  const [currency, setCurrency]       = useState("USDTTRC");
  const [orderTime, setOrderTime]     = useState("");
  const [timeLeft, setTimeLeft]       = useState(30 * 60);
  const [copied, setCopied]           = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!submitted) return;
    setTimeLeft(30 * 60);
    const interval = setInterval(() => {
      setTimeLeft(prev => (prev <= 0 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [submitted]);

  const formatTime = (secs) => {
    const m = String(Math.floor(secs / 60)).padStart(2, "0");
    const s = String(secs % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const now = new Date();
    const pad = n => String(n).padStart(2, "0");
    const formatted = `${now.getFullYear()}.${pad(now.getMonth()+1)}.${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())} ${now.getHours() >= 12 ? "PM" : "AM"}`;
    setOrderTime(formatted);
    setSubmitted(true);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">
        {/* Header */}
        <Header onToggleSidebar={() => setMobileMenuOpen(o => !o)} />
        {/* Sidebar */}
        <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} active="wallet" />
        {/* Main Content */}
        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">
              {/* Alerts */}
              <div className="row mb-5">
                <div className="alert alert-primary d-flex align-items-center" role="alert">
                  <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="1.5rem" viewBox="0 0 24 24" width="1.5rem" fill="#000000" className="flex-shrink-0 me-2 text-primary svg-danger"><g><rect fill="none" height="24" width="24"></rect></g><g><g><g><path d="M15.73,3H8.27L3,8.27v7.46L8.27,21h7.46L21,15.73V8.27L15.73,3z M19,14.9L14.9,19H9.1L5,14.9V9.1L9.1,5h5.8L19,9.1V14.9z"></path><rect height="6" width="2" x="11" y="7"></rect><rect height="2" width="2" x="11" y="15"></rect></g></g></g></svg>
                  <div>
                    - Minimum amount to deposit: <b>50 USD</b><br />
                    - Processing fee LTC, BTC: <b>4%</b><br />
                    - Processing fee USDT (trc20): <b>4$</b><br />
                    - To next <i className="ri-settings-line align-center"></i>Level need <b className="text-info">150$</b>{" "}
                    <a className="text-warning" href="#level"> What is the level bonus?</a>
                  </div>
                </div>
              </div>
              {/* <div className="mb-3 text-danger">
                <b>!!!!</b> High load on crypto services is causing instability and delays in deposits.<br />
                Rest assured, your transactions will be credited shortly.
              </div> */}
              {/* <div className="mb-3 text-danger">
                <b>Bitcoin cash, monero, TRC20,ERC20 currency exchange service is currently undergoing maintenance. <br />Only LTC and BTC currencies are available during this period. We apologize for any inconvenience caused and appreciate your patience.</b>
              </div> */}
              {/* Wallet Form + Payment UI */}
              <div className="row text-center justify-content-center mb-4">
                <div className="col-xl-12">
                  <div className="card custom-card d-flex">
                    <div className="card-header justify-content-between pb-0">
                      <div className="card-title">Wallet replenishment</div>
                    </div>
                    <div className="card-body">
                      {!submitted && (
                        <form onSubmit={handleSubmit} className="row g-2 align-items-center">
                          <div className="col-12 col-sm-auto">
                            <div className="form-floating">
                              <input type="text" name="usd" className="form-control" id="floatingInput" placeholder="Amount $" required value={amount} onChange={e => setAmount(e.target.value)} />
                              <label htmlFor="floatingInput">Amount $</label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-auto">
                            <div className="form-floating">
                              <select className="form-select" id="floatingSelect" name="from" style={{ minWidth: 200 }} value={currency} onChange={e => setCurrency(e.target.value)}>
                                <option value="USDTTRC">USDT (trc20)</option>
                                <option value="LTC">Litecoin</option>
                                <option value="BTC">Bitcoin</option>
                              </select>
                              <label htmlFor="floatingSelect">Select cryptocurrency</label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-auto">
                            <button className="btn btn-lg btn-primary w-100" type="submit">
                              <p className="wallet-sidebar-icon">$ Pay</p>
                            </button>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row text-center justify-content-center mb-5">
                <a href="#history" class="text-info"><h4>View my transaction history.</h4></a>
              </div>
              

              {/* Payment Response */}
              {submitted && (
                <div className="py-2">
                  <div className="row mb-5" style={{ alignItems: "stretch" }}>
                    {/* Order Info */}
                    <div className="col-12 col-md-3 col-xl-2">
                      <div className="card custom-card payment-card h-100">
                        <div className="card-body">
                          <ul className="list-group list-group-flush">
                            <li className="mt-3">Order ID:</li>
                            <li><b>-</b></li>
                            <li className="mt-3">Status:</li>
                            <li><b className="text-danger">New</b></li>
                            <li className="mt-3">Creation Time:</li>
                            <li><b>{orderTime}</b></li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Wallet Address */}
                    <div className="col-12 col-md-6 col-xl-8">
                      <div className="card custom-card payment-card h-100">
                        <div className="card-body">
                          <h3 className="pt-5 text-center">{WALLETS[currency].name}</h3>
                          <div className="block-crypto text-start">
                            <div className="mb-1 d-flex">
                              You have up to <b className="mx-1" style={{ minWidth: 50 }}>{formatTime(timeLeft)}</b> minutes to complete the payment, otherwise the request will be closed.
                            </div>
                            <div className="mb-1 d-flex">
                              Send <strong className="mx-2">{WALLETS[currency].label}</strong> to the address:
                              {copied && <span className="text-danger mx-2">copied</span>}
                            </div>
                            <div className="fs-20 fw-semibold copy-link-container" style={{ wordBreak: "break-all" }}>
                              <span className="text-danger" style={{ cursor: "pointer" }} onClick={() => handleCopy(WALLETS[currency].address)}>
                                <i className="fa fa-copy" title="Copy"></i>
                                <span className="px-1">{WALLETS[currency].address}</span>
                              </span>
                            </div>
                            <div className="fs-20 fw-semibold copy-link-container" style={{ wordBreak: "break-all" }}>
                              <span className="text-danger" style={{ cursor: "pointer" }} onClick={() => handleCopy("Any amount of currency")}>
                                <i className="fa fa-copy" title="Copy"></i>
                                <span className="px-1">Any amount of currency</span>
                              </span>
                            </div>
                          </div>
                          <div className="text-center mt-2">
                            <button className="btn btn-danger" onClick={() => setSubmitted(false)}>Create new transaction</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* QR Code */}
                    <div className="col-12 col-md-3 col-xl-2">
                      <div className="card custom-card payment-card h-100">
                        <div className="card-body d-flex align-items-center justify-content-center">
                          <img
                            src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${WALLETS[currency].address}`}
                            className="card-img-top"
                            alt="QR Code"
                            style={{ maxWidth: 200 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Timeline */}
                  <div className="row">
                    <div className="col-xxl-12">
                      <div className="timeline-container card">
                        <div className="card-body">
                          <ol className="clrfix" style={{ display: "flex", listStyle: "none", justifyContent: "center", alignItems: "center", gap: "12px", padding: 0, margin: 0 }}>
                            <li style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span className="ico deposit active" style={{ background: "#8fbd56", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.18.18 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.18.18 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.18.18 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.18.18 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.18.18 0 0 0 .134-.098z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5z"/></svg>
                              </span>
                              <label className="mb-0">New</label>
                            </li>
                            <li>&#9658;</li>
                            <li style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span style={{ background: "#8fbd56", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/><path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/><path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/><path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/></svg>
                              </span>
                              <label className="mb-0">Awaiting deposit</label>
                            </li>
                            <li>&#9658;</li>
                            <li style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span style={{ background: "#8fbd56", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5m2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2z"/></svg>
                              </span>
                              <label className="mb-0">Awaiting confirmations</label>
                            </li>
                            <li>&#9658;</li>
                            <li style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span style={{ background: "#8fbd56", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/></svg>
                              </span>
                              <label className="mb-0">Completed</label>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Level Info Table */}
              <div className="card custom-card" id="level">
                <div className="card-body border-0">
                  <p className="mb-4 text-17">Level Info</p>
                  <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>Level</th><th>Top-up</th><th>Discount</th><th>Status</th><th>Trust score</th>
                      </tr>
                      <tr className="table-success">
                        <th>Level 0</th><th>after registration</th><th>-</th><th>-</th><th>no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 1</th><th>after 150$</th><th>-0.10$</th><th>-</th><th>Trust 95%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 2</th><th>after 350$</th><th>-0.20$</th><th>-</th><th>Trust 90%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 3</th><th>after 700$</th><th>-0.30$</th><th>-</th><th>Trust 85%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 4</th><th>after 1,200$</th><th>-0.40$</th><th>-</th><th>Trust 75%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 5</th><th>after 2,000$</th><th>-0.50$</th><th>-</th><th>Trust 70%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 6</th><th>after 5,000$</th><th>-0.60$</th><th>-</th><th>Trust 68%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>- EXCELLENT BUYER</th><th>after 10,000$</th><th>-1$</th><th>EXCELLENT BUYER</th><th>Trust 68%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 7</th><th>after 12,000$</th><th>-1$</th><th>EXCELLENT BUYER</th><th>Trust 65%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>- MAJOR BUYER</th><th>after 20,000$</th><th>-1.50$</th><th>MAJOR BUYER</th><th>Trust 65%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 8</th><th>after 25,000$</th><th>-1.50$</th><th>MAJOR BUYER</th><th>Trust 63%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 9</th><th>after 35,000$</th><th>-1.50$</th><th>MAJOR BUYER</th><th>Trust 61%, if lower - no refund available</th>
                      </tr>
                      <tr>
                        <th>Level 10</th><th>after 50,000$</th><th>-1.50$</th><th>MAJOR BUYER</th><th>Trust 60%, if lower - no refund available</th>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
              {/* Transaction History */}
              <div className="row text-center justify-content-center" id="history">
                <div className="bg-white mb-4">
                  <div className="row">
                    <div className="col-xxl-12">
                      <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Hash</th>
                            <th scope="col">Address</th>
                            <th scope="col">Сurrency</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Rates</th>
                            <th scope="col">USD</th>
                            <th scope="col">Fee</th>
                            <th scope="col">Created at</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Transaction rows go here */}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Transaction History Link */}
              <div className="row text-center justify-content-center mb-5">
                <Link to="/wallet#history" className="text-info">
                  <h4>View my transaction history.</h4>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>
      </div>
      <style>{`
        :root {
          --primary09:rgba(143, 189, 86, 0.9);
        }
        .btn-primary:hover {
          color: #fff!important;
        }
        .payment-card {
          background: linear-gradient(135deg, #b8ccd8 0%, #7a97aa 100%) !important;
          border: none !important;
          color: #2c3e50;
        }
        .payment-card .card-body {
          background: transparent !important;
        }
        .payment-card h3 {
          color: #2c3e50;
        }
        .payment-card ul.list-group li {
          background: transparent;
          border: none;
          color: #2c3e50;
        }
        .timeline-container {
          background: #fff !important;
        }
        .timeline-container ol {
          display: flex;
          list-style: none;
          justify-content: center;
          align-items: center;
          gap: 12px;
          padding: 8px 0;
          margin: 0;
          flex-wrap: wrap;
        }
        @media (max-width: 767px) {
          .app-sidebar {
            position: fixed !important;
            left: -260px !important;
            top: 0 !important;
            height: 100vh !important;
            z-index: 1000 !important;
            transition: left 0.25s ease !important;
            overflow-y: auto !important;
          }
          .app-sidebar.mobile-open {
            left: 0 !important;
          }
          .app-sidebar .slide-menu {
            position: static !important;
            top: auto !important;
            margin-left: 0 !important;
            width: auto !important;
          }
          .app-content.main-content {
            margin-left: 0 !important;
            padding-left: 0 !important;
          }
          .page-main.is-expanded .app-content {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Wallet;
